import * as moment from 'moment-timezone';
import { FormGroup } from '@angular/forms';

export class PaymentFormCreditCardWidgetJson {
  getWidgetJson(form: FormGroup) {
    return {
      questions: [
        {
          'type': 'checkbox',
          'name': 'termsOfPayment',
          'isRequired': true,
          'requiredErrorText': 'Please agree to the Terms of Payment to continue',
          'titleLocation': 'hidden',
          'choices': [
            {
              'value': 'PaymentTerms',
              'text': 'I acknowledge and accept the Payment Terms referenced above.'
            }
          ],
          formControl: form.get('terms_of_payment'),
          controlName: 'terms_of_payment'
        },
        {
          'type': 'text',
          'name': 'ccnumber',
          'title': 'Card Number',
          'includeInOutput': true,
          'requiredErrorText': 'required',
          'isRequired': true,
          placeholder: '1234 5678 9012 3456',
          mask: '9999 9999 9999 9999',
          formControl: form.get('card_number'),
          controlName: 'card_number'
        }, {
          'type': 'text',
          'name': 'ccexpdate',
          'title': 'Expiration Date',
          'includeInOutput': true,
          'requiredErrorText': 'required',
          'isRequired': true,
          mask: '00/00',
          placeholder: 'mm/yy',
          min: moment().add(1, 'days').format('MM/YY'),
          max: moment().add(10, 'years').format('MM/YY'),
          formControl: form.get('expiration_date'),
          controlName: 'expiration_date'
        }, {
          'type': 'text',
          'name': 'name_on_card',
          'title': 'Name on Card',
          'placeholder': 'John Placeholder',
          'includeInOutput': true,
          'requiredErrorText': 'required',
          'isRequired': true,
          'startWithNewLine': false,
          formControl: form.get('name_on_card'),
          controlName: 'name_on_card'
        },
        {
          'type': 'text',
          'name': 'cctype',
          'title': 'CardType',
          'visible': false
        }]
    };
  }
}
